import api                from '@/api'
//import axios              from 'axios'
export default {
    data () {
        return {


            label_data  : {id:0, functions:{}},
            label_func  : {},
            incLabelNum : 0,
            issueID     : 0,
            pricesList  : []
                             
        }
      },
      mounted: function() {
        
        this.getPricesList();
  },  
    methods: {

        compareAtPrice(retailPrice)
        {
            let price 
            this.pricesList.forEach(item => {
                if(item.retailPrice==retailPrice)
                {
                    price = item.price
                }    
            });
            return price
        },
        async getPricesList()
            { 
              const sp   = {'sp' : 'spRetailPriceToLabelPriceList'}                      
              await api.post(sp).then(res => {
                if(res.status == 200)
                {
                  if(res.data.recordsets[0].length > 0)
                  {
                    
                    this.pricesList = res.data.recordsets[0]
                    //console.log(this.pricesList)
                    
                  }
                  
                }
              })

        },      

        getLabelData() {
            
            this.label_data.functions = this.label_func;
            this.label_func = {};
            this.incLabelNum = 0;

            return JSON.stringify(this.label_data);
        },
        setLabelId(setId) {
            this.label_data.id = setId;
        },
        checkLabelStatus() {
            const _a = {checkLabelStatus:[]};
            this.label_func["func"+this.incLabelNum] = _a;
            this.incLabelNum++;
        },
         
         clearBuffer() {
            const _a = {clearBuffer:[]};
            this.label_func["func"+this.incLabelNum] = _a;
            this.incLabelNum++;
        },
        printBuffer() { 
            let _a
            switch(arguments.length) {
            
            case 0:
                _a = {printBuffer:[]};
                this.label_func["func"+this.incLabelNum] = _a;
                this.incLabelNum++;
            break;
            case 1:
                _a = {printBuffer:[arguments[0]]};
                this.label_func["func"+incLabelNum] = _a;
                this.incLabelNum++;
            break;
        }
        },
        drawBlock(startHorizontal, startVertical, endHorizontal, endVertical, option, thickness) {
                let _a = {drawBlock:[startHorizontal, startVertical, endHorizontal, endVertical, option, thickness]};
                this.label_func["func"+this.incLabelNum] = _a;
                this.incLabelNum++;
        },
        draw1DBarcode(data, x, y, symbol, narrowbar, widebar, height, rotation, hri) {
            let _a = {draw1DBarcode:[data, x, y, symbol, narrowbar, widebar, height, rotation, hri]};
            this.label_func["func"+this.incLabelNum] = _a;
            this.incLabelNum++;
        },
        setWidth(width) {
            let _a = {setWidth:[width]};
            this.label_func["func"+this.incLabelNum] = _a;
            this.incLabelNum++;
        },
        drawDeviceFont(text, x, y, fontType, widthEnlarge, heightEnlarge, rotation, invert, bold, alignment) {
            let _a = {drawDeviceFont:[text, x, y, fontType, widthEnlarge, heightEnlarge, rotation, invert, bold, alignment]};
            this.label_func["func"+this.incLabelNum] = _a;
            this.incLabelNum++;
        }

    }
    

}